import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  Type,
  Anchor,
  Flex,
  Divider,
  DialogTitle,
  DialogTitleActions,
  UpdateBadge,
} from "discover.medical.react-component-library";
import { Link } from "react-router-dom";
import {
  StyledAlgorithmLogo,
  StyledViewAllUpdates,
  StyledDialogContent,
  StyledFooter,
} from "./_styled";
import { ALGORITHM_LOGO_URL } from "../../constants/ui";
import { updateTypes } from "../../constants/update-types";
import { tabTypes } from "../../constants/tab-types";

const TopicUpdatesDialog = ({
  isOpen,
  onClose,
  topicBaseUrl,
  updates,
  handleScrollTo,
  hash,
}) => {
  const dialogInfo = updates?.[0];
  const totalUpdates = updates?.length;
  const viewInTopicPath = `${topicBaseUrl}#${dialogInfo?.linkId}`;
  const viewAllUpdatesPath = `${topicBaseUrl}/${tabTypes.ALERTS}`;
  const handleNavigateToElement = () => {
    if (hash && dialogInfo?.linkId) {
      setTimeout(() => {
        handleScrollTo(dialogInfo?.linkId);
      }, 0);
    }
    onClose();
  };
  return (
    <Dialog
      isOpen={isOpen}
      maxWidth="sm"
      aria-labelledby="topic-updates-dialog-title"
      onRequestClose={onClose}
    >
      <DialogTitle>
        <DialogTitleActions onRequestClose={onClose} />
      </DialogTitle>
      <StyledDialogContent>
        {dialogInfo?.badge && (
          <UpdateBadge
            priority={dialogInfo.badge.priority}
            showSubPriority={dialogInfo.badge.healthEquity}
            text={dialogInfo.badge?.updateType}
            timestamp={dialogInfo.badge.timestamp}
          />
        )}
        <Flex container row marginTop="sm">
          {dialogInfo?.badge?.updateType === updateTypes.ALGORITHM && (
            <StyledAlgorithmLogo
              alt="Algorithm logo"
              src={ALGORITHM_LOGO_URL}
            />
          )}
          <div>
            <Type color="gray800" element="p">
              {dialogInfo?.text}
            </Type>
            {dialogInfo?.badge?.updateType !==
              updateTypes.TOPIC_LITERATURE_REVIEW && (
              <Anchor
                linkComponent={Link}
                onClick={handleNavigateToElement}
                href={viewInTopicPath}
              >
                View in topic
              </Anchor>
            )}
          </div>
        </Flex>
      </StyledDialogContent>
      {totalUpdates > 0 ? (
        <>
          <Divider />
          <StyledViewAllUpdates>
            <Anchor
              linkComponent={Link}
              onClick={onClose}
              href={viewAllUpdatesPath}
            >
              View All Updates
            </Anchor>
          </StyledViewAllUpdates>
        </>
      ) : (
        <StyledFooter />
      )}
    </Dialog>
  );
};

TopicUpdatesDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  handleScrollTo: PropTypes.func,
  hash: PropTypes.string,
  updates: PropTypes.shape({
    text: PropTypes.string,
    linkId: PropTypes.string,
    badge: PropTypes.shape({
      updateType: PropTypes.string,
      priorityText: PropTypes.string,
      icon: PropTypes.shape({
        glyph: PropTypes.string,
        info: PropTypes.string,
      }),
    }),
  }),
};

TopicUpdatesDialog.displayName = "TopicUpdatesDialog";
export default TopicUpdatesDialog;
